import { render } from "./AdminStatusPill.vue?vue&type=template&id=21bff2f8"
import script from "./AdminStatusPill.vue?vue&type=script&lang=js"
export * from "./AdminStatusPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__